import { render, staticRenderFns } from "./venues_manager.vue?vue&type=template&id=072c72f7&scoped=true&"
import script from "./venues_manager.vue?vue&type=script&lang=js&"
export * from "./venues_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c72f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072c72f7')) {
      api.createRecord('072c72f7', component.options)
    } else {
      api.reload('072c72f7', component.options)
    }
    module.hot.accept("./venues_manager.vue?vue&type=template&id=072c72f7&scoped=true&", function () {
      api.rerender('072c72f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/venues/venues_manager.vue"
export default component.exports